import { RoleType } from "@/types/RoleTypes";

export const hasAllPermissions = (role: RoleType | undefined) => {
  if (!role) {
    return false;
  }
  if (role.has_all_permissions) {
    return true;
  }
  return false;
};

export const hasHigherHierarchyThan = (
  currentUserRoleHierarchy: number,
  targetUserRoleHierarchy: number,
  isOwnRecord?: boolean,
) => {
  if (isOwnRecord) return true;
  return currentUserRoleHierarchy > targetUserRoleHierarchy;
};
